import { useEffect } from "react";

// GoHighLevel inline form embed for "The Dope Conversation Starter"
export const GhlForm = () => {
  useEffect(() => {
    const SRC = "https://link.integritygo.com/js/form_embed.js";
    if (document.querySelector(`script[src="${SRC}"]`)) return;
    const script = document.createElement("script");
    script.src = SRC;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <iframe
      src="https://link.integritygo.com/widget/form/GjnfE1t2l9BjBBcPEfLj"
      style={{ width: "100%", height: "747px", border: "none", borderRadius: "0px" }}
      id="inline-GjnfE1t2l9BjBBcPEfLj"
      data-layout="{'id':'INLINE'}"
      data-trigger-type="alwaysShow"
      data-trigger-value=""
      data-activation-type="alwaysActivated"
      data-activation-value=""
      data-deactivation-type="neverDeactivate"
      data-deactivation-value=""
      data-form-name="Dope Conversation Starter"
      data-height="747"
      data-layout-iframe-id="inline-GjnfE1t2l9BjBBcPEfLj"
      data-form-id="GjnfE1t2l9BjBBcPEfLj"
      title="Dope Conversation Starter"
      data-testid="ghl-lead-form"
    />
  );
};
